import { Element, InstallSpec } from "@p0security/shared/install/types";

export const AwsSmComponents = InstallSpec({
  "iam-write": {
    type: "dynamic",
    label: "Vault",
    description: "Allow P0 to vault credentials",
    maturity: "preview",
    schema: {
      defaultRegion: Element({
        label: "Default region for created secrets",
        type: "dynamic",
      }),
    },
  },
});
